"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayBackground = void 0;
const tslib_1 = require("tslib");
const phaser_1 = tslib_1.__importDefault(require("phaser"));
const GameplayRenderer_1 = require("../GameplayRenderer");
class GameplayBackground extends phaser_1.default.GameObjects.Container {
    constructor(scene) {
        super(scene);
        this.sprite = scene.add.sprite(0, 0, '__MISSING');
        this.add(this.sprite);
        this.sprite.setVisible(false);
    }
    setUrl(imageUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { isLoading, textureId } = GameplayRenderer_1.GameplayRenderer.getImageId(imageUrl, this.scene);
            this.expectedTextureId = textureId;
            const { scene } = this;
            const setTextureId = () => {
                var _a, _b;
                // console.error('texture key was', this.sprite.key);
                // console.error('was texture missing?', this.sprite.key === '__MISSING');
                this.sprite.setVisible(true);
                // manage previous texture
                let previousTextureKey;
                if ((_a = this.sprite.texture) === null || _a === void 0 ? void 0 : _a.key) {
                    previousTextureKey = this.sprite.texture.key;
                }
                this.sprite.setTexture(textureId);
                if (GameplayRenderer_1.GameplayRenderer.isLetterBox()) {
                    this.setLetterboxScaleAndPostion(textureId);
                }
                else {
                    this.setRegularScaleAndPostion(textureId);
                }
                if (previousTextureKey) {
                    (_b = this.sprite.scene) === null || _b === void 0 ? void 0 : _b.releaseTextureByKey(previousTextureKey);
                }
            };
            if (isLoading) {
                yield new Promise(resolve => {
                    GameplayRenderer_1.GameplayRenderer.imageLoadedHook(textureId, scene, tId => {
                        // TODO: need to avoid double call of setUrl from Story.js. Somehow it's happening on very start of gameplay
                        if (textureId === tId && tId === this.expectedTextureId) {
                            setTextureId();
                            resolve();
                        }
                    });
                });
            }
            else {
                setTextureId();
            }
        });
    }
    setRegularScaleAndPostion(textureId) {
        const frameData = this.scene.textures.getFrame(textureId, 0);
        const { height: gameHeight, centerX, centerY } = this.scene.cameras.main;
        this.sprite.setScale(gameHeight / frameData.height);
        this.setPosition(centerX, centerY);
    }
    setLetterboxScaleAndPostion(textureId) {
        const frameData = this.scene.textures.getFrame(textureId, 0);
        const { width: bgSpriteWidth, height: bgSpriteHeight } = frameData;
        const { viewportSize } = GameplayRenderer_1.GameplayRenderer.letterboxViewportSettings;
        const { width: viewportWidth, height: viewportHeight } = viewportSize;
        const scaleX = viewportWidth / bgSpriteWidth;
        const scaleY = viewportHeight / bgSpriteHeight;
        const bgScale = Math.max(scaleX, scaleY);
        const bgWidthScaled = bgSpriteWidth * bgScale;
        const bgHeightScaled = bgSpriteHeight * bgScale;
        this.sprite.setOrigin(0, 0);
        this.sprite.scale = bgScale;
        this.x = viewportWidth / 2 - bgWidthScaled / 2;
        this.y = viewportHeight / 2 - bgHeightScaled / 2;
    }
}
exports.GameplayBackground = GameplayBackground;
